import type { AssignmentSourceProbeRep } from '@gonfalon/openapi/types';
import { snackbarQueue } from '@launchpad-ui/components';

import {
  assignmentSourceBlockedFallbackMessage,
  assignmentSourceSizeWarningFallbackMessage,
} from './mapAssignmentSourceProbeToHealthCheck';

export function snackbarAssignmentSourceProbe(probe?: AssignmentSourceProbeRep) {
  if (!probe || probe.status === 'ok') {
    return;
  }

  if (probe.status === 'warn') {
    snackbarQueue.add({
      description: probe.warningMessage ?? assignmentSourceSizeWarningFallbackMessage,
      status: 'info',
    });
    return;
  }

  if (probe.status === 'blocked') {
    snackbarQueue.add({
      description: probe.blockMessage ?? assignmentSourceBlockedFallbackMessage,
      status: 'error',
    });
  }
}
